import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms and Conditions</h1>
        <p>
          Welcome to TeachMeGo! By creating an account or using our services, you agree to 
          these Terms and Conditions. Please read them carefully before proceeding.
        </p>

        <h2>1. Company Registration</h2>
        <p>
          TeachMeGo (Pty) Ltd is a registered company in South Africa with the 
          Companies and Intellectual Property Commission (CIPC). All services and 
          transactions conducted through TeachMeGo are governed by South African law.
        </p>

        <h2>2. User Accounts and Responsibilities</h2>
        <p>
          Users must provide accurate and complete information during registration. 
          You are solely responsible for maintaining the confidentiality of your 
          account credentials. Sharing accounts is strictly prohibited.
        </p>

        <h2>3. Tutor and Student Conduct</h2>
        <p>
          All users are expected to behave respectfully and professionally. Any 
          form of harassment, discrimination, or misconduct will not be tolerated 
          and may result in permanent account suspension.
        </p>

        <h2>4. Payments, Fees, and Commission</h2>
        <p>
          Payments for tutoring sessions must be made through the approved 
          TeachMeGo payment systems. Refund requests are subject to review 
          and approval by TeachMeGo.  
        </p>
        <p>
          TeachMeGo charges a <strong>10% service commission</strong> on each 
          session completed by tutors. This fee is automatically deducted from 
          the tutor’s earnings.
        </p>

        <h2>5. Service Availability</h2>
        <p>
          While TeachMeGo strives to provide a seamless experience, we do not 
          guarantee uninterrupted availability of our platform. We are not liable 
          for downtime, delays, or technical issues caused by external factors.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          TeachMeGo is a platform that connects students and tutors. We are not 
          responsible for the qualifications, behavior, or actions of individual 
          users. TeachMeGo is not liable for any damages, losses, or disputes 
          arising from tutoring sessions or interactions between users.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          All content, branding, and platform features are the intellectual 
          property of TeachMeGo. Users may not reproduce, distribute, or 
          reverse-engineer any part of the platform without permission.
        </p>

        <h2>8. Privacy and Data Protection</h2>
        <p>
          TeachMeGo complies with the Protection of Personal Information Act 
          (POPIA) of South Africa. By using our services, you consent to the 
          collection and processing of your personal information in accordance 
          with our Privacy Policy.
        </p>

        <h2>9. Account Suspension or Termination</h2>
        <p>
          TeachMeGo reserves the right to suspend or permanently terminate 
          accounts found to be in violation of these terms or engaged in any 
          unlawful or fraudulent activity.
        </p>

        <h2>10. Updates to Terms</h2>
        <p>
          TeachMeGo reserves the right to modify these Terms and Conditions at 
          any time. Changes will be effective immediately upon posting on the 
          platform. Continued use of TeachMeGo constitutes acceptance of 
          updated terms.
        </p>

        <p>
          By signing up, you confirm that you have read, understood, and agreed 
          to these Terms and Conditions.
        </p>

        <Link to="/auth" className="back-link">
          &larr; Back to Sign Up
        </Link>
      </div>
    </div>
  );
}

export default Terms;
